export const ExpenseClassEnum = {
    IngestedCCTransaction: 'IngestedCCTransaction',
    Reimbursement: 'Reimbursement',
    Payment: 'Payment',
    SalesGeneralAndAdmin: 'SalesGeneralAndAdmin',
    CreditCard: 'CreditCard',
    Vault: 'Vault',
};

export const ExpenseClassIdEnum = {
    IngestedCCTransaction: 0,
    Reimbursement: 1,
    Payment: 2,
    SalesGeneralAndAdmin: 3,
    Normal: 4,
    Vault: 5,
};

export default ExpenseClassEnum;
